import { inject, Injectable, Injector } from '@angular/core';
import { DataLoaderService } from './data-loader.service';
import type { SentryService } from './sentry.service';

type SentryUser = Parameters<SentryService['setUser']>[0];

@Injectable({
  providedIn: 'root',
})
export class LazyLoadedSentryService {
  private injector = inject(Injector);
  private loader = inject(DataLoaderService);
  private service: SentryService | undefined;
  private user: SentryUser | undefined;

  load(): Promise<SentryService> {
    return this.loader.get('lazy-loaded-sentry-service', () => {
      return new Promise(resolve => {
        import('./sentry.service').then(({ SentryService }) => {
          this.service = this.injector.get(SentryService);
          if (this.user) this.service.setUser(this.user);
          resolve(this.service);
        });
      });
    });
  }

  /** Tags later events with this user; doesn't load Sentry by itself. */
  setUser(user: SentryUser) {
    this.user = user;
    this.service?.setUser(user);
  }
}
